export default __webpack_public_path__ + "static/GRID22-map-conflict-es-450cf5563c09c8b332f5c77362f5c578.png";